// extracted by mini-css-extract-plugin
export default {"container":"Contact_container__UecWw","title":"Contact_title__Hrx-D","button":"Contact_button__witoa","icon":"Contact_icon__MNXno","contactBox":"Contact_contactBox__OrUpK"};